import { NgIf } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionExpiryWarningService } from './core/auth/session-expiry-warning.service';
import { NotificationHostComponent } from './shared/notification-host/notification-host.component';

@Component({
  selector: 'app-root',
  imports: [NgIf, RouterOutlet, NotificationHostComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly sessionExpiry = inject(SessionExpiryWarningService);
  protected readonly title = signal('badge');
  protected readonly sessionRemainingSeconds = this.sessionExpiry.remainingSeconds;
  protected readonly showSessionTimer = computed(() => {
    const remaining = this.sessionRemainingSeconds();
    return remaining !== null && remaining <= 60;
  });

  protected keepSessionAlive(): void {
    this.sessionExpiry.extendSession();
  }
}
